import React, { useEffect } from "react";
import Header from "../../Base/Header";
import UserDash from "../../Components/userDash/index.js";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      return navigate("/signin");
    }
    if (isAuthenticated() && isAuthenticated().role !== "user") {
      return navigate("/dash");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <UserDash />
      </div>
    </div>
  );
};

export default UserProfile;
